var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4272b8;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.75,16.76h1.58V14a22.62,22.62,0,0,0-2.3-.12c-2.28,0-3.85,1.44-3.85,4.07v2.43H17.67v3.08h2.51v6.66h3.09V23.46h2.42l.38-3.08h-2.8V18.26c0-.89.24-1.5,1.48-1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbnew);
export default __webpack_public_path__ + "static/media/fbnew.11fad377a99afe7121751209f23c2ae4.svg";
export { ForwardRef as ReactComponent };